<form [formGroup]="fg">
    <h2 class="text-center">Rediger bruger</h2>
    <div *ngIf="wrongInput" class="alert alert-danger">
        {{wrongInputReason}}
    </div>
    <!--<p>
        {{guideText}}
    </p>-->
    <hr>
    <div class="form-group"  *ngIf="!isSupervisor">
        <label>Brugernavn</label>
        <input formControlName="username" type="text" class="form-control form-control-sm" placeholder="Indtast brugernavn">
    </div>
    <div class="form-group">
        <label>Kodeord (efterlad blank hvis uændret)</label>
        <input formControlName="password" type="text" class="form-control form-control-sm" placeholder="Indtast evt nyt kodeord">
    </div>
    <!--<div class="form-group">
        <label></label>
        <textarea formControlName="placering" class="form-control form-control-sm" rows="4" placeholder="Indtast adresse"></textarea>
    </div>-->

    <div class="form-group">
        <label>Navn</label>
        <input formControlName="name" type="text" class="form-control form-control-sm" placeholder="Indtast navn">
    </div>
    <div class="form-group">
        <label>Email</label>
        <input formControlName="email" type="text" class="form-control form-control-sm" placeholder="Indtast email">
    </div>
    <hr>
    <div class="form-group float-right">
        <button class="btn btn-warning" [mat-dialog-close]="false">Annuller</button>
        <button type="submit" class="btn btn-primary" (click)="doSubmit()">Rediger</button>
    </div>
</form>